// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PoHeader } from './po-header';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Warehouse extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Binary */
  rowVersion!: any;
  /** String(50) */
  whAddress1!: string;
  /** String(50) */
  whAddress2?: string;
  /** String(50) */
  whCity!: string;
  /** String(25) */
  whFax?: string;
  /** String(50) */
  whName!: string;
  /** String(10) */
  whState!: string;
  /** String(25) */
  whTelephone?: string;
  /** String(10) */
  whZipCode!: string;
  /** Inv FK shippingWarehouseId */
  poHeaders!: PoHeader[];
}

